// src/pages/super-admin/SuperAdminDashboardPage.js - Super Admin 대시보드

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faUsers, faArrowRight, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { getEnterpriseAccounts, getCompanies } from '../../services/api';
import './SuperAdminDashboardPage.scss';

function SuperAdminDashboardPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ enterpriseCount: 0, companyCount: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const [entData, teamData] = await Promise.all([
          getEnterpriseAccounts({ per_page: 1, account_type: 'business' }).catch(() => ({ total_count: 0 })),
          getCompanies({ per_page: 1 }).catch(() => ({ total_count: 0 })),
        ]);
        setStats({
          enterpriseCount: entData.total_count || 0,
          companyCount: teamData.total_count || 0,
        });
      } catch (err) {
        console.error('통계 조회 실패:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  return (
    <div className="super-admin-dashboard">
      <div className="sa-page-header">
        <h1 className="sa-page-title">대시보드</h1>
        <p className="sa-page-subtitle">서비스 관리 현황</p>
      </div>

      {/* 통계 카드 */}
      <div className="sa-stats-grid">
        <div className="sa-stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/super-admin/enterprises')}>
          <div className="sa-stat-label">기업 계정</div>
          <div className="sa-stat-value accent">
            {loading ? '...' : stats.enterpriseCount}
          </div>
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#6b7280' }}>
            <FontAwesomeIcon icon={faBuilding} style={{ fontSize: 12 }} />
            <span>기업 계정 관리</span>
            <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: 10, marginLeft: 'auto' }} />
          </div>
        </div>

        <div className="sa-stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/super-admin/companies')}>
          <div className="sa-stat-label">기업</div>
          <div className="sa-stat-value accent">
            {loading ? '...' : stats.companyCount}
          </div>
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#6b7280' }}>
            <FontAwesomeIcon icon={faUsers} style={{ fontSize: 12 }} />
            <span>기업 관리</span>
            <FontAwesomeIcon icon={faArrowRight} style={{ fontSize: 10, marginLeft: 'auto' }} />
          </div>
        </div>
      </div>

      {/* 빠른 실행 */}
      <div className="sa-table-container" style={{ padding: 24 }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, color: '#111827', margin: '0 0 16px 0' }}>빠른 실행</h3>
        <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <button className="sa-btn sa-btn-primary" onClick={() => navigate('/super-admin/analytics')}>
            <FontAwesomeIcon icon={faChartLine} /> 운영 애널리틱스
          </button>
          <button className="sa-btn sa-btn-secondary" onClick={() => navigate('/super-admin/enterprises')}>
            <FontAwesomeIcon icon={faBuilding} /> 기업 계정 관리
          </button>
          <button className="sa-btn sa-btn-secondary" onClick={() => navigate('/super-admin/companies')}>
            <FontAwesomeIcon icon={faUsers} /> 기업 관리
          </button>
        </div>
      </div>
    </div>
  );
}

export default SuperAdminDashboardPage;
